export async function subscribe(axios, payload) {
  await axios.post("/subscribeTopic", payload);
}
export async function unsubscribe(axios, payload) {
  await axios.post("/unsubscribeTopic", payload);
}